/* Copyright 2014 The MathWorks, Inc. */

/**
 * The UIBuilder acts as a facade on top of ModelManager and WidgetManager and exposes some of their functions as the
 * UIBuilder's public API. This module defines that list of functions that the UIBuilder should expose from the
 * ModelManager and WidgetManager.
 */

define({
    fromModelManager: [
        "create", "destroy", "add", "remove", "get", "set", "exists",
        "indexOf", "getChildrenIds", "getParentId", "isAnOrphan",
        "addEventCallback", "addPropertySetCallback", "createCorrespondingComponentInQAB",
        "createPopupsFromConfig", "addTabGroupFromConfig", "addStatusBarFromConfig",
        "createGalleryPopupFromConfig", "addGalleryItemToFavorites", "removeGalleryItemFromFavorites",
        "getGalleryState", "setGalleryState",
        "getQABState", "setQABState",
        "widgetByTag", "tagToId",
        "showPopup",

        "addToolstripFromConfig",
        "placeToolstripAt", "selectTab", "selectFirstTabInTabGroup",
        "getMenubarWrapperWidget", "getToolbarWrapperWidget", "lazyLoadQABItems"
    ],
    fromWidgetManager: [
        "refreshGallery", "isAnyPopupOpen", "closeAllOpenPopups"
    ]
});